
const figureObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                figureStepAdd(target)
                // 可见区域后 下次不在执行监听
                figureObserver.unobserve(target)
            }
        }) 
    },
    {
        // 默认值为null，也就是视口区域,表示监听的可视区域为整个视口，也就是浏览器的可视区域
        root: null,
        // 属性决定了什么时候触发回调函数。默认为[0] 比如，[0, 0.25, 0.5, 0.75, 1]就表示当目标元素 0%、25%、50%、75%、100% 可见时，会触发回调函数。
        threshold: [1],
        // 定义根元素的margin,用来扩展可视区的范围,或者可以这样理解，root元素，多了一个margin属性，如果没有这个margin属性，
        // ele元素只有与root元素开始交叉时才会触发可视性的变化，而这个rootMargin属性的话，就是当ele元素与root元素的外边距交叉时，就会触发ele元素的可视性变化。
        rootMargin: '0px'
    }
)

let eles = document.querySelectorAll('.figure-step-add')
for(let ele of eles){
    figureObserver.observe(ele)
}

const figureStepAdd = ele => {
    let figure = ele.getAttribute('figure') || 0,
        startVal = 0;
    ele.innerHTML = 0;
    let interval1 = setInterval(() => {
        if(startVal + 10 < figure) {
            startVal = startVal + 10
            ele.innerHTML = startVal
        } else {
            clearInterval(interval1)
            let interval2 = setInterval(() => {
                if(startVal + 1 <= figure) {
                    startVal = startVal + 1
                    ele.innerHTML = startVal
                } else {
                    clearInterval(interval2)
                    // let interval3 = setInterval(() => {
                    //     if(startVal + 1 <= figure) {
                    //         startVal = startVal + 1
                    //         ele.innerHTML = startVal
                    //     } else {
                    //         clearInterval(interval3)
                    //     }
                    // }, 300)
                }
            }, 200)
        }
    },100)
}


const barWidthObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                target.style.animation = 'barIncreaseWidth 3s ease'
                barWidthObserver.unobserve(target)
            }
        }) 
    },
    {
        root: null,
        threshold: [1],
        rootMargin: '0px'
    }
)


let barWidthList = document.querySelectorAll('.chart-item-bar-width')
for(let bar of barWidthList){
    barWidthObserver.observe(bar)
}

const barHeightObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                target.style.animation = 'barIncreaseHeight 2s ease'
                barHeightObserver.unobserve(target)
            }
        }) 
    },
    {
        root: null,
        threshold: [1],
        rootMargin: '0px'
    }
)


let barHeightList = document.querySelectorAll('.chart-item-bar-height')
for(let bar of barHeightList){
    barHeightObserver.observe(bar)
}


const bubbleObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                bubbleAnimation()
                bubbleObserver.unobserve(target)
            }
        }) 
    },
    {
        root: null,
        threshold: [1],
        rootMargin: '0px'
    }
)

const bubbleAnimation = () => {
    const bubbleFirsts =  document.querySelectorAll('.bubble-first');
    const bubbleSeconds =  document.querySelectorAll('.bubble-second');
    const bubbleThirds =  document.querySelectorAll('.bubble-third');
    for(const bubble of bubbleFirsts) {
        bubble.style.opacity = '1'
    }
    setTimeout(() => {
        for(const bubble of bubbleSeconds) {
            bubble.style.opacity = '1'
        }
    }, 1000)
    setTimeout(() => {
        for(const bubble of bubbleThirds) {
            bubble.style.opacity = '1'
        }
    }, 2000)
}


let bubbleArea = document.getElementById('the-bubble-area')
bubbleObserver.observe(bubbleArea)



const sectorObserver = new IntersectionObserver(
    (entries) => {
        console.log(entries.length, 'entries.length')
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                sectorAnimation(target)
                sectorObserver.unobserve(target)
            }
        }) 
    },
    {
        root: null,
        threshold: [1],
        rootMargin: '0px'
    }
)

let sector = document.getElementById('chart-first')
sectorObserver.observe(sector)

const sectorAnimation = ele => {
    let figure = ele.getAttribute('figure') || 0,
        startVal = 0;
        ele.style.background = 'conic-gradient(#D53239 0, #FF847D 0%, #ececec 0%, #ececec 100%)';
    let interval = setInterval(() => {
        if(startVal + 10 <= figure) {
            startVal = startVal + 10
            ele.style.background = `conic-gradient(#D53239 0, #FF847D ${startVal}%, #ececec ${Number(startVal) + .5}%, #ececec 100%)`;
        } else {
            ele.style.background = `conic-gradient(#D53239 0, #FF847D ${figure}%, #ececec ${Number(figure) + .5}%, #ececec 100%)`;
            clearInterval(interval)
        }
    },100)
}
